export const articles: Record<string, {
  id: string;
  title: string;
  date: string;
  category: string;
  readTime: string;
  author: string;
  image: string;
  content: Array<{ type: "p" | "h2" | "h3" | "image" | "quote"; text?: string; src?: string; alt?: string }>;
  relatedArticles: string[];
}> = {
  "product-01": {
    id: "product-01",
    title: "爱威奶儿童成长配方——科学营养助力健康成长",
    date: "2026-07-15",
    category: "儿童系列",
    readTime: "5分钟",
    author: "爱威奶营养研究中心",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20toned%20minimalist%20product%20photography%20of%20a%20carton%20of%20milk%20on%20a%20cream%20colored%20wooden%20surface%20with%20soft%20natural%20window%20light%20casting%20gentle%20shadows%20clean%20elegant%20composition%20with%20a%20small%20plant%20in%20background%20warm%20and%20inviting%20atmosphere&width=1200&height=600&seq=article-product-01&orientation=landscape",
    content: [
      { type: "p", text: "在孩子的成长过程中，科学合理的营养摄入至关重要。爱威奶儿童成长配方专为3-12岁儿童研发，以科学的营养配比和优质的原料，为孩子的健康成长提供全面支持。本文将为您详细介绍这款产品的独特优势和使用建议。" },
      { type: "h2", text: "为什么儿童需要专属营养配方？" },
      { type: "p", text: "3-12岁是儿童身体和智力发展的黄金时期。在这个阶段，儿童需要充足的钙质来支持骨骼生长，需要DHA来促进大脑发育，还需要多种维生素和矿物质来维持免疫系统功能。普通成人配方无法完全满足儿童特殊的营养需求。" },
      { type: "p", text: "爱威奶儿童成长配方由专业营养师团队根据中国儿童膳食指南精心研发，针对儿童生长发育特点，科学配比了多种关键营养素，确保每一口都为孩子的成长助力。" },
      { type: "h3", text: "核心营养成分解析" },
      { type: "p", text: "爱威奶儿童成长配方中含有以下核心营养成分：高含量钙质（每100ml含120mg钙），助力骨骼和牙齿健康发育；优质DHA藻油，促进大脑和视力发育；维生素A、C、D、E复合配方，增强免疫力；铁、锌、硒等微量元素，支持全面健康成长；优质乳清蛋白，易于消化吸收。" },
      { type: "h2", text: "家长真实反馈" },
      { type: "p", text: "许多家长反馈，孩子在饮用爱威奶儿童成长配方后，不仅身高体重增长更理想，注意力也更加集中，整体精神状态有明显改善。一位来自北京的张妈妈分享道：\"孩子喝了半年，体检时各项指标都非常理想，而且孩子特别喜欢这个味道，每天早晚都主动要喝。\"" },
      { type: "p", text: "爱威奶始终坚持原料可追溯、生产透明化的原则，每一批次产品都经过严格的品控检测，确保每一位小消费者都能享受到安全、营养、美味的优质产品。" },
      { type: "h2", text: "使用建议" },
      { type: "p", text: "建议每日早晚各饮用150-200ml，可单独饮用或搭配早餐。最佳饮用温度为常温或微温（40-50℃），不建议高温加热以免破坏营养成分。开封后请密封冷藏保存，建议在30天内饮用完毕。" },
    ],
    relatedArticles: ["product-02", "guide-01", "child-02"],
  },
  "guide-01": {
    id: "guide-01",
    title: "爱威奶正确饮用指南——这样喝效果更好",
    date: "2026-07-20",
    category: "使用指南",
    readTime: "8分钟",
    author: "爱威奶营养研究中心",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20lifestyle%20photography%20of%20a%20person%20pouring%20milk%20into%20a%20glass%20on%20a%20sunlit%20kitchen%20counter%20cream%20colored%20interior%20soft%20morning%20light%20cozy%20and%20inviting%20atmosphere%20minimalist%20composition&width=1200&height=600&seq=article-guide-01&orientation=landscape",
    content: [
      { type: "p", text: "掌握爱威奶的正确饮用方法，可以让营养吸收效率提升数倍。很多消费者虽然选择了爱威奶，但由于饮用方式不当，未能充分发挥产品的营养价值。本文将为您提供全方位的饮用指导。" },
      { type: "h2", text: "最佳饮用时间" },
      { type: "p", text: "早餐时段（7:00-8:00）：搭配面包、麦片等主食，为一天的活动提供充足能量。运动后30分钟内：此时身体对蛋白质和碳水化合物的吸收效率最高，是补充运动消耗的最佳时机。睡前1小时：温热饮用有助于放松身心，促进睡眠质量。" },
      { type: "h2", text: "适宜饮用温度" },
      { type: "p", text: "爱威奶在不同温度下呈现出不同的口感特点。常温饮用能最大程度保留营养成分，口感清爽；微温饮用（40-50℃）则更加醇厚顺滑，适合寒冷季节。需要注意的是，不建议用沸水加热，因为超过60℃会破坏部分活性营养物质。" },
      { type: "h3", text: "每日建议饮用量" },
      { type: "p", text: "根据不同年龄段和身体需求，爱威奶的每日建议饮用量有所不同：儿童（3-12岁）每日200-300ml，青少年（12-18岁）每日300-400ml，成人每日250-400ml，中老年人每日200-300ml。运动人群可根据运动强度适当增加至每日400-500ml。" },
      { type: "h2", text: "搭配建议" },
      { type: "p", text: "爱威奶可以与多种食物搭配食用，以增强营养吸收效果。搭配全麦面包和鸡蛋，构成营养均衡的早餐；搭配新鲜水果，增加维生素摄入；搭配坚果，补充健康脂肪。建议避免与浓茶、咖啡同时饮用，以免影响钙质吸收。" },
    ],
    relatedArticles: ["product-01", "guide-02", "guide-03"],
  },
  "review-01": {
    id: "review-01",
    title: "真实用户评测：爱威奶儿童系列半年使用感受",
    date: "2026-07-18",
    category: "用户评测",
    readTime: "6分钟",
    author: "爱威奶用户社区",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20heartwarming%20photography%20of%20a%20child%20happily%20drinking%20milk%20at%20a%20sunlit%20breakfast%20table%20cream%20colored%20interior%20soft%20natural%20light%20genuine%20joyful%20moment%20minimalist%20lifestyle%20composition&width=1200&height=600&seq=article-review-01&orientation=landscape",
    content: [
      { type: "p", text: "作为一名注重孩子营养健康的妈妈，我在半年前开始给孩子使用爱威奶儿童系列。以下是这六个月来的真实使用感受和客观评测，希望能为同样在寻找优质儿童营养品的家长们提供参考。" },
      { type: "h2", text: "选择爱威奶的原因" },
      { type: "p", text: "在决定尝试爱威奶之前，我对比了市面上多个品牌的儿童营养奶产品。爱威奶吸引我的主要有三点：一是成分表清晰透明，没有任何我看不懂的添加物；二是钙和DHA含量在同价位产品中处于领先水平；三是众多用户的真实好评给了我尝试的信心。" },
      { type: "h2", text: "六个月使用详情" },
      { type: "p", text: "第一个月：孩子对口味接受度很高，没有出现任何不适反应。我注意到他早上喝了奶之后，上午的精神状态明显更好了。第三个月：带孩子去做了常规体检，身高体重都在正常增长轨道上，微量元素指标也比上次检查时要理想。医生也认可了我们的营养补充方案。" },
      { type: "p", text: "第六个月：最明显的感受是孩子的免疫力有所提升。之前换季时容易感冒，这半年虽然也有小感冒但恢复速度明显加快，病程也缩短了不少。" },
      { type: "h2", text: "总体评价与建议" },
      { type: "p", text: "总体来说，爱威奶儿童系列是一款性价比很高的儿童营养产品。口味孩子喜欢，营养成分专业合理，使用半年没有发现任何质量问题。建议家长们可以从小包装开始尝试，观察孩子的接受程度后再决定是否长期使用。另外，营养品只是补充，均衡的日常饮食和充足的户外运动同样重要。" },
    ],
    relatedArticles: ["product-01", "child-01", "child-02"],
  },
};

export const getArticleById = (id: string) => {
  return articles[id] || null;
};

export const getRelatedArticles = (ids: string[]) => {
  return ids.map((id) => articles[id]).filter(Boolean);
};